/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React from 'react';
import { changeLanguage } from 'redux/modules/i18n';
import { connect } from 'react-redux';
import CookieUtils from 'frilans-finans/utils/cookie-utils';

export class LocaleListItem extends React.Component {

  static propTypes = {
    lang: React.PropTypes.string,
    dispatch: React.PropTypes.func
  };

  constructor (props) {
    super(props);

    this.boundOnChangeLanguage = this.onChangeLanguage.bind(this);
  }

  onChangeLanguage () {
    this.props.dispatch(changeLanguage(this.props.lang));
    CookieUtils.setLanguageCookie(this.props.lang);
    location.reload();
  }

  render () {
    let classNames = 'sprite-image flag-' + this.props.lang;

    return (
      <li onClick={this.boundOnChangeLanguage}>
        <span className={classNames}/>
      </li>
    );
  }
}

export default connect()(LocaleListItem);



/** WEBPACK FOOTER **
 ** ./src/components/header/locale-picker/locale-list-item.js
 **/